import React, { useEffect, useState } from 'react';
import { devCost, fmtAED } from '../utils';
import { useNavigate } from 'react-router-dom';
import { productsAPI } from '../api';

const STATUS_LABELS = {
  trial: 'Trial', recipe_confirmed: 'Recipe Confirmed',
  commercial_trial: 'Commercial Trial', launched: 'Launched',
};

export default function GroupView() {
  const [grouped, setGrouped] = useState({});
  const [filterSfg, setFilterSfg] = useState('');
  const [selectedGroup, setSelectedGroup] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    productsAPI.getAll({}).then(r => {
      const g = {};
      r.data.forEach(p => {
        const grp = p.internal_group || 'Unassigned';
        if (!g[grp]) g[grp] = [];
        g[grp].push(p);
      });
      setGrouped(g);
      if (Object.keys(g).length > 0) setSelectedGroup(Object.keys(g)[0]);
    });
  }, []);

  const groups = Object.keys(grouped).sort();

  return (
    <div>
      <div className="page-header">
        <div>
          <div className="page-title">Products by Internal Group</div>
          <div className="page-subtitle">Group-based view for internal product categorisation</div>
        </div>
      </div>

      <div style={{ display: 'flex', gap: 24 }}>
        <div style={{ width: 220, flexShrink: 0 }}>
          <div className="card" style={{ padding: '12px 8px' }}>
            <div className="card-title" style={{ padding: '0 10px', marginBottom: 10 }}>Groups</div>
            {groups.map(g => {
              const gProds = grouped[g];
              const totalCost = gProds.reduce((s, p) => s + devCost(p), 0);
              return (
                <div
                  key={g}
                  onClick={() => setSelectedGroup(g)}
                  style={{
                    padding: '10px 12px',
                    borderRadius: 6,
                    cursor: 'pointer',
                    background: selectedGroup === g ? 'var(--accent-dim)' : 'transparent',
                    borderLeft: selectedGroup === g ? '2px solid var(--accent)' : '2px solid transparent',
                    marginBottom: 2,
                    transition: 'all 0.15s',
                  }}
                >
                  <div style={{ fontWeight: 700, fontSize: 12, color: selectedGroup === g ? 'var(--accent)' : 'var(--text-primary)', fontFamily: 'DM Mono, monospace' }}>{g}</div>
                  <div className="text-muted" style={{ fontSize: 11 }}>{gProds.length} products</div>
                  <div className="cost-value mono" style={{ fontSize: 11 }}>AED {totalCost.toLocaleString('en-IN', { maximumFractionDigits: 0 })}</div>
                </div>
              );
            })}
            {groups.length === 0 && <div className="text-muted" style={{ padding: '0 10px', fontSize: 13 }}>No groups yet</div>}
          </div>
        </div>

        <div style={{ flex: 1 }}>
          {selectedGroup && grouped[selectedGroup] ? (
            <>
              <div className="stats-grid mb-6">
                {['trial', 'recipe_confirmed', 'commercial_trial', 'launched'].map(s => (
                  <div key={s} className="stat-card">
                    <div className="stat-label">{STATUS_LABELS[s]}</div>
                    <div className="stat-value">{grouped[selectedGroup].filter(p => p.status === s).length}</div>
                  </div>
                ))}
              </div>

              <div className="card">
                <div className="card-title mono">{selectedGroup} — All Products</div>
                <div className="table-wrap">
                  <table>
                    <thead>
                      <tr>
                        <th>Product Code</th>
                        <th>Name</th>
                        <th>Project</th>
                        <th>Department</th>
                        <th>Status</th>
                        <th className="text-right">Recipe Cost</th>
                      </tr>
                    </thead>
                    <tbody>
                      {grouped[selectedGroup].map(p => (
                        <tr key={p.id} onClick={() => navigate(`/products/${p.id}`)}>
                          <td className="mono">{p.product_code}</td>
                          <td style={{ fontWeight: 500 }}>{p.name}</td>
                          <td className="text-muted">{p.project_name}</td>
                          <td>{p.department}</td>
                          <td><span className={`badge badge-${p.status}`}>{STATUS_LABELS[p.status]}</span></td>
                          <td className="text-right cost-value">
                            {(devCost(p)) > 0 ? `AED ${(devCost(p)).toLocaleString('en-AE', { maximumFractionDigits: 0 })}` : '—'}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </>
          ) : (
            <div className="empty-state card">
              <div className="empty-state-icon">◫</div>
              <p>No groups yet. Groups are assigned when creating products.</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
